/* FRM Reviews — Frontend JS
 * Handles:
 *  1. Batch star ratings for product cards
 *  2. Product page review section (load, filter, load-more)
 *  3. Review submission form
 *  4. Homepage gallery carousel
 *  5. Photo lightbox
 */
(function () {
  'use strict';
  if (window.FRM_INITIALIZED) return;
  window.FRM_INITIALIZED = true;


  // ── Config ────────────────────────────────────────────────────────────────
  // API URL is set by the Liquid section as a data attribute on the root element.
  // Fallback to window.FRM_API_URL if set in theme.liquid.
  function getApiUrl(el) {
    return (el && el.dataset.frmApi) || window.FRM_API_URL || '';
  }

  // ── Star render helpers ───────────────────────────────────────────────────
  function starsHtml(avg, size) {
    size = size || 14;
    const full  = Math.floor(avg);
    const half  = (avg - full) >= 0.4 ? 1 : 0;
    const empty = 5 - full - half;
    const s = px => `font-size:${px}px`;
    return (
      '<span class="frm-stars">' +
      '★'.repeat(full).split('').map(() => `<span class="frm-star full" style="${s(size)}">★</span>`).join('') +
      (half ? `<span class="frm-star half" style="${s(size)}">★</span>` : '') +
      '★'.repeat(empty).split('').map(() => `<span class="frm-star empty" style="${s(size)}">★</span>`).join('') +
      '</span>'
    );
  }

  function esc(s) {
    return String(s || '')
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function fmtDate(str) {
    if (!str) return '';
    const d = new Date(str);
    return isNaN(d) ? str : d.toLocaleDateString('en-US', { year:'numeric', month:'short', day:'numeric' });
  }

  // "Zack and Destiny Miller" → "Zack A." (Loox 스타일 이름 축약 — 스니펫 전용)
  function truncateName(name) {
    var parts = (name || '').trim().split(/\s+/);
    if (parts.length < 2) return name || '';
    return parts[0] + ' ' + parts[1].charAt(0).toUpperCase() + '.';
  }

  // ── 1. Batch star ratings for product cards ───────────────────────────────
  function initProductCardRatings() {
    const cards = document.querySelectorAll('.frm-rating[data-frm-id]');
    if (!cards.length) return;

    // Determine API URL from the first card's ancestor or from global
    const apiUrl = (function () {
      const el = cards[0].closest('[data-frm-api]');
      return (el && el.dataset.frmApi) || window.FRM_API_URL || '';
    })();

    const ids = [...new Set([...cards].map(c => c.dataset.frmId))].filter(Boolean);
    if (!ids.length || !apiUrl) return;

    fetch(`${apiUrl}/api/ratings?product_ids=${ids.join(',')}`)
      .then(r => r.json())
      .then(data => {
        cards.forEach(card => {
          const pid = card.dataset.frmId;
          const info = data[pid];
          if (!info || !info.count) {
            card.style.display = 'none';
            return;
          }
          card.innerHTML =
            starsHtml(info.avg, 13) +
            `<span class="frm-rating-count">(${info.count})</span>`;
        });
      })
      .catch(() => { cards.forEach(c => (c.style.display = 'none')); });
  }

  // ── 2. Product page review section ───────────────────────────────────────
  function initReviewSection() {
    const root = document.getElementById('frm-reviews-root');
    if (!root) return;

    const apiUrl    = getApiUrl(root);
    const productId = root.dataset.productId;
    if (!apiUrl || !productId) return;

    let page       = 1;
    let photosOnly = false;
    let loading    = false;
    let hasMore    = true;
    let totalCount = 0;
    let avgRating  = 0;

    const summaryEl   = root.querySelector('.frm-histogram-panel');
    const gridEl      = root.querySelector('.frm-review-grid');

    // 마소니 컬럼 초기화 (Liquid 스켈레톤 대체)
    initMasonryCols(gridEl);
    const loadMoreBtn = root.querySelector('.frm-load-more-btn');
    const filterAll   = root.querySelector('.frm-filter-all');
    const filterPhoto = root.querySelector('.frm-filter-photo');
    const perPage     = parseInt(root.dataset.limit) || 12;

    // Filters
    if (filterAll) {
      filterAll.addEventListener('click', () => {
        photosOnly = false;
        filterAll.classList.add('active');
        filterPhoto && filterPhoto.classList.remove('active');
        resetAndLoad();
      });
    }

    if (filterPhoto) {
      filterPhoto.addEventListener('click', () => {
        photosOnly = true;
        filterPhoto.classList.add('active');
        filterAll && filterAll.classList.remove('active');
        resetAndLoad();
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => { if (!loading && hasMore) loadPage(); });
    }

    // 히스토그램 패널 토글
    const ratingToggle   = root.querySelector('.frm-rating-toggle');
    const histogramPanel = root.querySelector('.frm-histogram-panel');
    if (ratingToggle && histogramPanel) {
      ratingToggle.addEventListener('click', () => {
        const expanded = histogramPanel.classList.toggle('open');
        ratingToggle.setAttribute('aria-expanded', String(expanded));
        const chevron = ratingToggle.querySelector('.frm-topbar-chevron');
        if (chevron) chevron.textContent = expanded ? '▲' : '▼';
        if (expanded) {
          setTimeout(function() {
            histogramPanel.querySelectorAll('.frm-bar-fill').forEach(function(f) {
              f.style.backgroundSize = (parseFloat(f.dataset.pct) || 0) + '% 100%';
            });
          }, 50);
        }
      });
    }

    // "Write a Review" button
    const writeBtn = root.querySelector('.frm-write-btn');
    if (writeBtn) {
      writeBtn.addEventListener('click', () => openModal(root, apiUrl, productId, onReviewSubmitted));
    }

    function onReviewSubmitted() {
      resetAndLoad();
      loadStats();
    }

    function resetAndLoad() {
      page = 1;
      hasMore = true;
      initMasonryCols(gridEl);
      loadPage();
    }

    async function loadStats() {
      const qs = new URLSearchParams({ product_id: productId });
      const data = await fetch(`${apiUrl}/api/reviews?${qs}&limit=1`).then(r => r.json()).catch(() => null);
      if (!data) return;
      avgRating  = data.avg_rating || 0;
      totalCount = data.num_reviews || 0;
      renderSummary(data, summaryEl);
    }

    async function loadPage() {
      if (loading || !hasMore) return;
      loading = true;
      if (loadMoreBtn) loadMoreBtn.disabled = true;

      const qs = new URLSearchParams({
        product_id:  productId,
        page:        page,
        limit:       perPage,
        photos_only: photosOnly ? '1' : '0',
      });

      const data = await fetch(`${apiUrl}/api/reviews?${qs}`).then(r => r.json()).catch(() => null);
      loading = false;

      if (!data) {
        if (loadMoreBtn) loadMoreBtn.disabled = false;
        return;
      }

      // Render summary on first page
      if (page === 1) {
        avgRating  = data.avg_rating || 0;
        totalCount = data.num_reviews || 0;
        renderSummary(data, summaryEl);
        injectSeoSchema(data, root);
      }

      renderReviews(data.reviews, gridEl, apiUrl);

      const loaded = (page - 1) * perPage + data.reviews.length;
      hasMore = loaded < (photosOnly ? data.with_photo : data.total);
      page++;

      if (loadMoreBtn) {
        loadMoreBtn.style.display = hasMore ? 'inline-block' : 'none';
        loadMoreBtn.disabled = false;
      }

      // First load with no reviews
      if (page === 2 && !data.reviews.length) {
        gridEl.innerHTML = '<div class="frm-empty">No reviews yet. Be the first to write one!</div>';
      }
    }

    loadPage();
  }

  // ── 마소니 그리드 헬퍼 ───────────────────────────────────────────────────────
  function colCount() {
    var w = window.innerWidth;
    if (w > 1199) return 5;
    if (w > 900)  return 4;
    if (w > 767)  return 3;
    return 2;
  }

  function initMasonryCols(gridEl) {
    gridEl.innerHTML = '';
    gridEl._cardIdx = 0;
    var n = colCount();
    for (var i = 0; i < n; i++) {
      var col = document.createElement('div');
      col.className = 'frm-masonry-col';
      gridEl.appendChild(col);
    }
  }

  // ── Letter avatar helpers ─────────────────────────────────────────────────
  const AVATAR_COLORS = [
    '#E57373','#F06292','#BA68C8','#7986CB','#4FC3F7',
    '#4DB6AC','#81C784','#FFB74D','#FF8A65','#A1887F'
  ];

  function avatarColor(name) {
    let h = 0;
    for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
    return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
  }

  function avatarLetter(name) {
    return (name || '?').trim().charAt(0).toUpperCase();
  }

  function renderSummary(data, el) {
    if (!el) return;
    const avg = data.avg_rating || 0;
    const total = data.num_reviews || 0;
    const dist  = data.distribution || {};

    const scoreEl = el.querySelector('.frm-avg-score');
    if (scoreEl) scoreEl.textContent = avg ? avg.toFixed(1) : '—';
    const starsEl = el.querySelector('.frm-avg-stars');
    if (starsEl) starsEl.innerHTML = starsHtml(avg, 20);
    const metaEl = el.querySelector('.frm-avg-meta');
    if (metaEl) metaEl.textContent = total + (total === 1 ? ' review' : ' reviews');

    // 상단바 컴팩트 표시
    var rootEl = el.closest('#frm-reviews-root');
    if (rootEl) {
      var tbStars = rootEl.querySelector('.frm-topbar-stars');
      if (tbStars) tbStars.innerHTML = starsHtml(avg, 13);
      var tbAvg = rootEl.querySelector('.frm-topbar-avg');
      if (tbAvg) tbAvg.textContent = avg ? avg.toFixed(1) : '—';
      var tbCount = rootEl.querySelector('.frm-topbar-count');
      if (tbCount) tbCount.textContent = total + (total === 1 ? ' Review' : ' Reviews');
    }

    // Histogram
    const histEl = el.querySelector('.frm-histogram');
    if (histEl && total > 0) {
      [5,4,3,2,1].forEach(n => {
        const cnt   = dist[n] || 0;
        const pct   = total ? Math.round(cnt / total * 100) : 0;
        const fill  = histEl.querySelector(`.frm-bar-fill[data-star="${n}"]`);
        const count = histEl.querySelector(`.frm-bar-count[data-star="${n}"]`);
        if (fill) {
          fill.dataset.pct = pct;
          fill.style.backgroundSize = pct + '% 100%';
        }
        if (count) count.textContent = cnt;
      });
    }
  }

  function injectSeoSchema(data, rootEl) {
    if (!data.avg_rating || !data.num_reviews) return;
    const productTitle = rootEl.dataset.productTitle || document.title;
    const productUrl   = rootEl.dataset.productUrl   || window.location.href;

    const aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: String(data.avg_rating),
      bestRating: '5',
      worstRating: '1',
      ratingCount: String(data.num_reviews),
      reviewCount: String(data.num_reviews),
    };

    const reviewItems = (data.reviews || []).slice(0, 5).map(function(r) {
      return {
        '@type': 'Review',
        reviewRating: { '@type': 'Rating', ratingValue: String(r.rating), bestRating: '5', worstRating: '1' },
        name: r.title || r.body.substring(0, 80),
        author: { '@type': 'Person', name: r.reviewer_name },
        reviewBody: r.body,
        datePublished: r.created_at ? r.created_at.substring(0, 10) : undefined,
      };
    });

    // Augment existing Product JSON-LD if present (avoids duplicate Product entities)
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var obj = JSON.parse(scripts[i].textContent);
        var t = obj['@type'];
        if (t === 'Product' || (Array.isArray(t) && t.indexOf('Product') !== -1)) {
          obj.aggregateRating = aggregateRating;
          if (reviewItems.length) obj.review = reviewItems;
          scripts[i].textContent = JSON.stringify(obj);
          return;
        }
      } catch (e) {}
    }

    // No existing Product JSON-LD — create one
    var schema = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: productTitle,
      url: productUrl,
      aggregateRating: aggregateRating,
    };
    if (reviewItems.length) schema.review = reviewItems;
    var el = document.createElement('script');
    el.type = 'application/ld+json';
    el.textContent = JSON.stringify(schema);
    document.head.appendChild(el);
  }

  function renderReviews(reviews, gridEl, apiUrl) {
    if (!reviews || !reviews.length) return;
    gridEl.querySelectorAll('.frm-skeleton-card').forEach(el => el.remove());
    // 이미지 있는 리뷰를 앞으로 정렬
    const sorted = [...reviews].sort((a, b) => (b.photo_url ? 1 : 0) - (a.photo_url ? 1 : 0));
    const cols = gridEl.querySelectorAll('.frm-masonry-col');
    const n = cols.length;
    if (!('_cardIdx' in gridEl)) gridEl._cardIdx = 0;
    sorted.forEach((r, i) => {
      const card = buildReviewCard(r, apiUrl);
      card.style.animationDelay = (i * 30) + 'ms';
      if (n > 0) {
        // 라운드로빈: 카드를 순서대로 각 컬럼에 배분
        cols[gridEl._cardIdx % n].appendChild(card);
        gridEl._cardIdx++;
      } else {
        gridEl.appendChild(card);
      }
    });
  }

  function buildReviewCard(r, apiUrl) {
    const card = document.createElement('div');
    card.className = 'frm-review-card';

    const photoUrl = r.photo_url
      ? (r.photo_url.startsWith('/api/images/') ? apiUrl + r.photo_url : r.photo_url)
      : null;

    const name = r.reviewer_name || 'Customer';
    const color = avatarColor(name);
    const letter = avatarLetter(name);

    const verifiedHtml = r.verified
      ? `<span class="frm-verified-text"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true" style="vertical-align:-2px;flex-shrink:0"><circle cx="6.5" cy="6.5" r="6.5" fill="currentColor"/><path d="M3.8 6.8 5.5 8.5 9.5 4.5" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg> Verified</span>`
      : '';

    if (photoUrl) {
      card.innerHTML = `
        <div class="frm-review-photo-wrapper">
          <img class="frm-review-photo" src="${esc(photoUrl)}" alt="Review photo by ${esc(name)}" loading="lazy">
        </div>
        <div class="frm-review-body">
          <div class="frm-reviewer-name-row">
            <span class="frm-reviewer-name">${esc(name)}</span>
            ${verifiedHtml}
          </div>
          <div class="frm-reviewer-date">${esc(fmtDate(r.created_at))}</div>
          <div class="frm-review-stars">${starsHtml(r.rating, 13)}</div>
          ${r.title ? `<div class="frm-review-title">${esc(r.title)}</div>` : ''}
          <div class="frm-review-text">${esc(r.body)}</div>
        </div>`;
    } else {
      card.classList.add('frm-card--text');
      card.innerHTML = `
        <div class="frm-review-body">
          <div class="frm-card-avatar-header">
            <div class="frm-inline-avatar" style="background:${color}">${letter}</div>
            <div class="frm-card-meta">
              <div class="frm-reviewer-name-row">
                <span class="frm-reviewer-name">${esc(name)}</span>
                ${verifiedHtml}
              </div>
              <div class="frm-reviewer-date">${esc(fmtDate(r.created_at))}</div>
              <div class="frm-review-stars">${starsHtml(r.rating, 13)}</div>
            </div>
          </div>
          ${r.title ? `<div class="frm-review-title">${esc(r.title)}</div>` : ''}
          <div class="frm-review-text">${esc(r.body)}</div>
        </div>`;
    }

    if (photoUrl) {
      card.querySelector('.frm-review-photo').addEventListener('click', () => openLightbox(photoUrl));
    }

    // "Read more / Read less" toggle
    const textEl = card.querySelector('.frm-review-text');
    const bodyEl = card.querySelector('.frm-review-body');
    requestAnimationFrame(() => {
      if (textEl.scrollHeight > textEl.clientHeight + 2) {
        const btn = document.createElement('button');
        btn.className = 'frm-read-more-btn';
        btn.textContent = 'Read more';
        btn.addEventListener('click', () => {
          const expanded = textEl.classList.toggle('expanded');
          btn.textContent = expanded ? 'Read less' : 'Read more';
        });
        bodyEl.appendChild(btn);
      }
    });

    return card;
  }

  // ── 3. Review submission form ─────────────────────────────────────────────
  let globalModal = null;

  function openModal(rootEl, apiUrl, productId, onSuccess) {
    if (!globalModal) globalModal = buildModal();

    const overlay = globalModal;
    overlay.dataset.apiUrl    = apiUrl;
    overlay.dataset.productId = productId;

    // Store the product handle from the page if available
    const handleEl = rootEl.dataset.productHandle || document.querySelector('[data-product-handle]')?.dataset.productHandle || '';
    overlay.dataset.productHandle = handleEl;

    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';

    // Reset form
    overlay.querySelector('.frm-modal-form').reset();
    overlay.querySelector('.frm-photo-preview').classList.remove('visible');
    overlay.querySelector('.frm-photo-drop').classList.remove('has-file');
    overlay.querySelector('.frm-photo-drop-text').textContent = 'Click or drag photo here (optional)';
    overlay.querySelectorAll('.frm-star-picker span').forEach(s => s.classList.remove('lit'));
    overlay.querySelector('.frm-selected-rating').value = '';
    const msg = overlay.querySelector('.frm-form-msg');
    msg.className = 'frm-form-msg';

    overlay._onSuccess = onSuccess;

    overlay.querySelector('input[name="name"]').focus();
  }

  function buildModal() {
    const overlay = document.createElement('div');
    overlay.className = 'frm-modal-overlay';
    overlay.innerHTML = `
      <div class="frm-modal">
        <button class="frm-modal-close" type="button" aria-label="Close">✕</button>
        <h2>Write a Review</h2>
        <form class="frm-modal-form" novalidate>
          <input type="hidden" name="rating" class="frm-selected-rating">

          <div class="frm-form-group">
            <label class="frm-label">Rating <span class="required">*</span></label>
            <div class="frm-star-picker" role="radiogroup">
              <span data-val="1" title="1 star">★</span>
              <span data-val="2" title="2 stars">★</span>
              <span data-val="3" title="3 stars">★</span>
              <span data-val="4" title="4 stars">★</span>
              <span data-val="5" title="5 stars">★</span>
            </div>
          </div>

          <div class="frm-form-group">
            <label class="frm-label">Your Name <span class="required">*</span></label>
            <input type="text" name="name" class="frm-input" placeholder="First name & last initial" required maxlength="80">
          </div>

          <div class="frm-form-group">
            <label class="frm-label">Email <span style="color:#aaa;font-weight:400">(not published)</span></label>
            <input type="email" name="email" class="frm-input" placeholder="you@email.com" maxlength="120">
          </div>

          <div class="frm-form-group">
            <label class="frm-label">Review Title</label>
            <input type="text" name="title" class="frm-input" placeholder="Summarize your experience" maxlength="120">
          </div>

          <div class="frm-form-group">
            <label class="frm-label">Review <span class="required">*</span></label>
            <textarea name="body" class="frm-textarea" placeholder="Tell others about your experience…" required maxlength="2000"></textarea>
          </div>

          <div class="frm-form-group">
            <label class="frm-label">Photo (optional)</label>
            <div class="frm-photo-drop" role="button" tabindex="0">
              <input type="file" name="photo" accept="image/jpeg,image/png,image/webp,image/gif" style="display:none">
              <div class="frm-photo-drop-text">Click or drag photo here (optional)</div>
              <img class="frm-photo-preview" alt="Preview">
            </div>
          </div>

          <div class="frm-form-msg"></div>
          <button type="submit" class="frm-submit-btn">Submit Review</button>
        </form>
      </div>`;

    // Star picker
    const picker = overlay.querySelector('.frm-star-picker');
    const ratingInput = overlay.querySelector('.frm-selected-rating');
    picker.querySelectorAll('span').forEach(star => {
      const val = parseInt(star.dataset.val);
      star.addEventListener('mouseover', () => highlightStars(picker, val));
      star.addEventListener('mouseout',  () => highlightStars(picker, parseInt(ratingInput.value) || 0));
      star.addEventListener('click',     () => {
        ratingInput.value = val;
        highlightStars(picker, val);
      });
    });

    // Photo drop
    const drop = overlay.querySelector('.frm-photo-drop');
    const fileInput = drop.querySelector('input[type=file]');
    const preview   = drop.querySelector('.frm-photo-preview');
    const dropText  = drop.querySelector('.frm-photo-drop-text');

    drop.addEventListener('click', () => fileInput.click());
    drop.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') fileInput.click(); });
    drop.addEventListener('dragover', e => { e.preventDefault(); drop.style.borderColor = '#aaa'; });
    drop.addEventListener('dragleave', () => { drop.style.borderColor = ''; });
    drop.addEventListener('drop', e => {
      e.preventDefault();
      drop.style.borderColor = '';
      const file = e.dataTransfer.files[0];
      if (file) setPhotoFile(file, fileInput, preview, drop, dropText);
    });
    fileInput.addEventListener('change', () => {
      if (fileInput.files[0]) setPhotoFile(fileInput.files[0], fileInput, preview, drop, dropText);
    });

    // Close
    overlay.querySelector('.frm-modal-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

    // Submit
    overlay.querySelector('.frm-modal-form').addEventListener('submit', async e => {
      e.preventDefault();
      await handleSubmit(overlay);
    });

    document.body.appendChild(overlay);
    return overlay;
  }

  function highlightStars(picker, val) {
    picker.querySelectorAll('span').forEach(s => {
      s.classList.toggle('lit', parseInt(s.dataset.val) <= val);
    });
  }

  function setPhotoFile(file, input, preview, drop, dropText) {
    const allowed = ['image/jpeg','image/png','image/webp','image/gif'];
    if (!allowed.includes(file.type)) { alert('Please upload a JPG, PNG, WEBP, or GIF image.'); return; }
    if (file.size > 10 * 1024 * 1024) { alert('Image must be under 10MB.'); return; }

    // Assign to the file input via DataTransfer
    try {
      const dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
    } catch {}

    const reader = new FileReader();
    reader.onload = ev => {
      preview.src = ev.target.result;
      preview.classList.add('visible');
      drop.classList.add('has-file');
      dropText.textContent = file.name;
    };
    reader.readAsDataURL(file);
  }

  async function handleSubmit(overlay) {
    const form        = overlay.querySelector('.frm-modal-form');
    const msgEl       = overlay.querySelector('.frm-form-msg');
    const submitBtn   = overlay.querySelector('.frm-submit-btn');
    const apiUrl      = overlay.dataset.apiUrl;
    const productId   = overlay.dataset.productId;
    const productHandle = overlay.dataset.productHandle || '';

    const name   = form.querySelector('[name=name]').value.trim();
    const email  = form.querySelector('[name=email]').value.trim();
    const title  = form.querySelector('[name=title]').value.trim();
    const body   = form.querySelector('[name=body]').value.trim();
    const rating = form.querySelector('.frm-selected-rating').value;

    msgEl.className = 'frm-form-msg';

    if (!name)   return showMsg(msgEl, 'error', 'Please enter your name.');
    if (!rating) return showMsg(msgEl, 'error', 'Please select a rating.');
    if (!body)   return showMsg(msgEl, 'error', 'Please write your review.');

    const fd = new FormData();
    fd.append('name',           name);
    fd.append('email',          email);
    fd.append('rating',         rating);
    fd.append('title',          title);
    fd.append('body',           body);
    fd.append('product_id',     productId);
    fd.append('product_handle', productHandle);

    const photoFile = form.querySelector('[name=photo]').files[0];
    if (photoFile) fd.append('photo', photoFile);

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    try {
      const res  = await fetch(`${apiUrl}/api/reviews`, { method: 'POST', body: fd });
      const data = await res.json();
      if (data.success) {
        showMsg(msgEl, 'success', data.message || 'Review submitted! It will appear after approval.');
        form.reset();
        overlay.querySelectorAll('.frm-star-picker span').forEach(s => s.classList.remove('lit'));
        overlay.querySelector('.frm-photo-preview').classList.remove('visible');
        overlay.querySelector('.frm-photo-drop').classList.remove('has-file');
        overlay.querySelector('.frm-photo-drop-text').textContent = 'Click or drag photo here (optional)';
        if (overlay._onSuccess) setTimeout(overlay._onSuccess, 800);
        setTimeout(closeModal, 3000);
      } else {
        showMsg(msgEl, 'error', data.error || 'Submission failed. Please try again.');
      }
    } catch {
      showMsg(msgEl, 'error', 'Network error. Please try again.');
    }

    submitBtn.disabled = false;
    submitBtn.textContent = 'Submit Review';
  }

  function closeModal() {
    if (globalModal) globalModal.classList.remove('open');
    document.body.style.overflow = '';
  }

  function showMsg(el, type, text) {
    el.className = 'frm-form-msg ' + type;
    el.textContent = text;
  }

  // ── 4. Inline star rating section ────────────────────────────────────────
  function initStarRatingSection() {
    const root = document.getElementById('frm-star-rating-root');
    if (!root) return;

    const apiUrl     = getApiUrl(root);
    const productId  = root.dataset.productId;
    const limit      = parseInt(root.dataset.snippetsCount) || 4;
    const showRating = root.dataset.showRating !== 'false';
    const showImg    = root.dataset.showImage  !== 'false';
    const fontSize   = parseInt(root.dataset.fontSize) || 13;
    const showBorder = root.dataset.showBorder === 'true';
    const radius     = parseInt(root.dataset.borderRadius) || 12;
    if (!apiUrl || !productId) return;

    // Apply CSS variables from block/section settings
    root.style.setProperty('--frm-snippet-radius', radius + 'px');
    root.style.setProperty('--frm-snippet-font-size', fontSize + 'px');
    if (!showBorder) root.style.setProperty('--frm-snippet-border-color', 'transparent');

    // showRating: top summary (avg score + count)를 show/hide — 개별 별점이 아님
    const summaryDiv = root.querySelector('.frm-star-rating-summary');
    if (!showRating && summaryDiv) summaryDiv.style.display = 'none';

    const starsEl  = root.querySelector('.frm-star-rating-stars');
    const avgEl    = root.querySelector('.frm-star-rating-avg');
    const countEl  = root.querySelector('.frm-star-rating-count');
    const stripEl  = root.querySelector('.frm-snippets-strip');
    const prevBtn  = root.querySelector('.frm-snippets-prev');
    const nextBtn  = root.querySelector('.frm-snippets-next');

    fetch(`${apiUrl}/api/reviews?product_id=${productId}&page=1&limit=${limit}`)
      .then(r => r.json())
      .then(data => {
        const avg   = data.avg_rating || 0;
        const total = data.num_reviews || 0;
        if (!total) { root.style.display = 'none'; return; }

        if (starsEl) starsEl.innerHTML = starsHtml(avg, 15);
        if (avgEl)   avgEl.textContent = avg.toFixed(1);
        if (countEl) {
          countEl.textContent = `${total} Review${total === 1 ? '' : 's'}`;
          countEl.href = '#frm-reviews-root';
        }

        if (!stripEl || !data.reviews || !data.reviews.length) return;

        data.reviews.forEach(r => {
          const photoUrl = r.photo_url
            ? (r.photo_url.startsWith('/api/images/') ? apiUrl + r.photo_url : r.photo_url)
            : null;
          const name   = r.reviewer_name || 'Customer';
          const color  = avatarColor(name);
          const letter = avatarLetter(name);

          const card = document.createElement('div');
          card.className = 'frm-snippet-card';
          card.innerHTML = `
            ${showImg && photoUrl
              ? `<img class="frm-snippet-thumb" src="${esc(photoUrl)}" alt="${esc(name)}" loading="lazy">`
              : `<div class="frm-snippet-avatar" style="background:${color}">${letter}</div>`}
            <div class="frm-snippet-content">
              <div class="frm-snippet-header-row">
                <span class="frm-snippet-name">${esc(truncateName(name))}</span>
                <span class="frm-snippet-stars">${starsHtml(r.rating, 14)}</span>
              </div>
              <div class="frm-snippet-text">${esc(r.body)}</div>
            </div>`;
          if (showImg && photoUrl) {
            card.querySelector('.frm-snippet-thumb').addEventListener('click', e => {
              e.stopPropagation(); openLightbox(photoUrl);
            });
          }
          card.addEventListener('click', () => {
            const target = document.getElementById('frm-reviews-root');
            if (target) target.scrollIntoView({ behavior: 'smooth' });
          });
          stripEl.appendChild(card);
        });

        // 카드를 track-wrap 너비로 맞춰 한 번에 하나씩 표시
        const trackWrap = stripEl.parentElement;
        function sizeSnipCards() {
          var w = trackWrap ? trackWrap.offsetWidth : 0;
          if (!w) return;
          stripEl.querySelectorAll('.frm-snippet-card').forEach(function(c) {
            c.style.width = w + 'px';
            c.style.flexBasis = w + 'px';
          });
        }
        // 레이아웃 확정 후 측정 (RAF + setTimeout 폴백 + ResizeObserver)
        requestAnimationFrame(sizeSnipCards);
        setTimeout(sizeSnipCards, 150);
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(sizeSnipCards).observe(trackWrap);
        }

        // Snippet carousel navigation
        if (prevBtn && nextBtn) {
          let snipOffset = 0;

          function snipCardW() {
            const c = stripEl.querySelector('.frm-snippet-card');
            return c ? c.offsetWidth + 10 : 250;
          }
          function snipVisible() {
            return Math.max(1, Math.floor(trackWrap.offsetWidth / snipCardW()));
          }
          function updateSnipNav() {
            const total = stripEl.children.length;
            const vis   = snipVisible();
            prevBtn.disabled = snipOffset <= 0;
            nextBtn.disabled = snipOffset + vis >= total;
            const carousel = prevBtn.closest('.frm-snippets-carousel');
            if (carousel) carousel.classList.toggle('frm-snippets-no-nav', total <= vis);
          }
          prevBtn.addEventListener('click', () => {
            snipOffset = Math.max(0, snipOffset - snipVisible());
            stripEl.style.transform = `translateX(-${snipOffset * snipCardW()}px)`;
            updateSnipNav();
          });
          nextBtn.addEventListener('click', () => {
            const total = stripEl.children.length;
            snipOffset = Math.min(total - snipVisible(), snipOffset + snipVisible());
            stripEl.style.transform = `translateX(-${snipOffset * snipCardW()}px)`;
            updateSnipNav();
          });
          updateSnipNav();
        }
      })
      .catch(() => { root.style.display = 'none'; });
  }

  // ── 5. Homepage gallery carousel ─────────────────────────────────────────
  function initGalleryCarousel() {
    const root = document.getElementById('frm-gallery-root');
    if (!root) return;

    const apiUrl = getApiUrl(root);
    if (!apiUrl) return;

    const track     = root.querySelector('.frm-gallery-track');
    const trackWrap = root.querySelector('.frm-gallery-track-wrap');
    const prevBtn   = root.querySelector('.frm-gallery-prev');
    const nextBtn   = root.querySelector('.frm-gallery-next');
    if (!track || !trackWrap) return;

    const GAP = 20; // must match CSS gap on .frm-gallery-track
    let offset = 0;
    let itemW  = 220;

    function visibleCount() { return window.innerWidth <= 767 ? 1 : 5; }

    function calcItemPx() {
      const vis  = visibleCount();
      const wrap = trackWrap.offsetWidth || 1000;
      return Math.max(80, Math.floor((wrap - (vis - 1) * GAP) / vis));
    }

    function applyItemSizes() {
      const px  = calcItemPx();
      const mid = Math.round(px / 2);
      track.querySelectorAll('.frm-gallery-item').forEach(item => {
        item.style.width     = px + 'px';
        item.style.flexBasis = px + 'px';
        const circle = item.querySelector('.frm-gallery-circle');
        if (circle) { circle.style.width = px + 'px'; circle.style.height = px + 'px'; }
      });
      itemW = px + GAP;
      if (prevBtn) prevBtn.style.top = mid + 'px';
      if (nextBtn) nextBtn.style.top = mid + 'px';
    }

    function updateNav() {
      const total = track.children.length;
      if (prevBtn) prevBtn.disabled = offset <= 0;
      if (nextBtn) nextBtn.disabled = offset + visibleCount() >= total;
    }

    // Size skeleton items immediately so no 6th item shows during load
    requestAnimationFrame(applyItemSizes);

    fetch(`${apiUrl}/api/gallery?limit=30`)
      .then(r => r.json())
      .then(data => {
        if (!data.reviews || !data.reviews.length) {
          root.style.display = 'none';
          return;
        }
        track.querySelectorAll('.frm-gallery-skeleton').forEach(el => el.remove());
        data.reviews.forEach(r => {
          const photoUrl = r.photo_url
            ? (r.photo_url.startsWith('/api/images/') ? apiUrl + r.photo_url : r.photo_url)
            : null;
          if (!photoUrl) return;

          const item = document.createElement('div');
          item.className = 'frm-gallery-item';
          const stars = '★'.repeat(r.rating) + '☆'.repeat(5 - r.rating);
          item.innerHTML = `
            <div class="frm-gallery-circle">
              <img src="${esc(photoUrl)}" alt="${esc(r.reviewer_name)}'s review" loading="lazy">
              <div class="frm-gallery-overlay">
                <div class="frm-gallery-reviewer">${esc(r.reviewer_name)}${r.verified ? ' ✓' : ''}</div>
                <div class="frm-gallery-stars">${stars}</div>
              </div>
            </div>`;
          item.addEventListener('click', () => openLightbox(photoUrl));
          track.appendChild(item);
        });

        requestAnimationFrame(() => { applyItemSizes(); updateNav(); });
      })
      .catch(() => { root.style.display = 'none'; });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const total = track.children.length;
        offset = Math.min(offset, Math.max(0, total - visibleCount()));
        applyItemSizes();
        track.style.transform = `translateX(-${offset * itemW}px)`;
        updateNav();
      }, 150);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (offset <= 0) return;
        offset = Math.max(0, offset - 1);
        track.style.transform = `translateX(-${offset * itemW}px)`;
        updateNav();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const total = track.children.length;
        if (offset + visibleCount() >= total) return;
        offset = Math.min(total - visibleCount(), offset + 1);
        track.style.transform = `translateX(-${offset * itemW}px)`;
        updateNav();
      });
    }

    let touchStartX = 0;
    track.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', e => {
      const dx = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(dx) < 30) return;
      if (dx > 0 && nextBtn && !nextBtn.disabled) nextBtn.click();
      if (dx < 0 && prevBtn && !prevBtn.disabled) prevBtn.click();
    }, { passive: true });
  }

  // ── 5. Photo lightbox ────────────────────────────────────────────────────
  let lightbox = null;

  function openLightbox(src) {
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'frm-lightbox-overlay';
      lightbox.innerHTML = `
        <button class="frm-lightbox-close" aria-label="Close">✕</button>
        <img class="frm-lightbox-img" src="" alt="Review photo">`;
      lightbox.querySelector('.frm-lightbox-close').addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });
      document.body.appendChild(lightbox);
    }
    lightbox.querySelector('.frm-lightbox-img').src = src;
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (lightbox) lightbox.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeLightbox(); closeModal(); }
  });

  // ── Init ─────────────────────────────────────────────────────────────────
  function init() {
    initProductCardRatings();
    initReviewSection();
    initStarRatingSection();
    initGalleryCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ── Shopify Customize live-preview re-init ────────────────────────────────
  // Fires when section settings change in the editor → re-run the relevant init
  document.addEventListener('shopify:section:load', function(e) {
    var t = e.target;
    if (t.querySelector('#frm-star-rating-root')) {
      var strip = t.querySelector('.frm-snippets-strip');
      if (strip) strip.innerHTML = '';
      initStarRatingSection();
    }
    if (t.querySelector('#frm-reviews-root')) {
      var grid = t.querySelector('.frm-review-grid');
      if (grid) { grid.querySelectorAll('.frm-skeleton-card').forEach(function(el) { el.remove(); }); grid.innerHTML = ''; }
      initReviewSection();
    }
    if (t.querySelector('#frm-gallery-root')) {
      var track = t.querySelector('.frm-gallery-track');
      if (track) track.innerHTML = '';
      initGalleryCarousel();
    }
  });

})();
